document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.featured_collection_slider_main').forEach(function (colltabsider) {
    const tabButtons = colltabsider.querySelectorAll('.featured_collection_tab_button');
    const tabPanels = colltabsider.querySelectorAll('.featured_collection_tab_panel');
    let currentIndex = Array.from(tabPanels).findIndex(el => el.classList.contains('active'));
    let isAnimating = false;

    tabPanels.forEach(content => {
      content.style.display = content.classList.contains('active') ? 'block' : 'none';
    });

    const swipers = [];
    tabPanels.forEach(panel => {
      const swiperEl = panel.querySelector('.featured_collection_slider_swiper');
      if (swiperEl) {
        const swiper = new Swiper(swiperEl, {
          slidesPerView: 1,
          spaceBetween: 16,
          observer: true,          
          observeParents: true,     
          watchSlidesProgress: true, 
          navigation: {
            nextEl: panel.querySelector('.featured_collection_slider_button_next'),
            prevEl: panel.querySelector('.featured_collection_slider_button_prev'),
          },
          breakpoints: {
            900: { slidesPerView: 2 },
            1024: { slidesPerView: 3.5 },
          },
        });
        swipers.push(swiper);
      }
    });

    tabButtons.forEach((btn, index) => {
      btn.addEventListener('click', () => {
        if (isAnimating || index === currentIndex) return;
        isAnimating = true;

        tabButtons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        const current = tabPanels[currentIndex];
        const next = tabPanels[index];

        current.classList.remove('active');
        setTimeout(() => {
          current.style.display = 'none';
          next.style.display = 'block';
          setTimeout(() => {
            next.classList.add('active');
            
            const swiperInstance = swipers[index];
            if (swiperInstance) {
              swiperInstance.update();
              swiperInstance.slideTo(0, 0);
            }

            currentIndex = index;
            isAnimating = false;
          }, 10);
        }, 300);
      });
    });
  });
});





// document.addEventListener('DOMContentLoaded', function() {
//   document.querySelectorAll('.featured_collection_slider_main').forEach(function(colltabsider) {
//     const tabButtons = colltabsider.querySelectorAll('.featured_collection_tab_button');
//     const tabPanels = colltabsider.querySelectorAll('.featured_collection_tab_panel');
//     let currentIndex = Array.from(tabPanels).findIndex(el => el.classList.contains('active'));
//     let isAnimating = false;
//     let swipers = [];
  
//    tabPanels.forEach((content, index) => {
//     content.style.display = content.classList.contains('active') ? 'block' : 'none';
//     });
//     tabButtons.forEach((btn, index) => {
//       btn.addEventListener('click', () => {
//         if (isAnimating || index === currentIndex) return;
//         isAnimating = true;
//         tabButtons.forEach(b => b.classList.remove('active'));
//         btn.classList.add('active');
//         const current = tabPanels[currentIndex];
//         current.classList.remove('active');
//         setTimeout(() => {
//           current.style.display = 'none';
//           const next = tabPanels[index];
//           next.style.display = 'block';
//           setTimeout(() => {
//             next.classList.add('active');
//             if (swipers[index]) {
//               swipers[index].update(); 
//               swipers[index].slideTo(0, 0);
//             }
//             currentIndex = index;
//             isAnimating = false;
//           }, 10);
//         }, 300);
//       });
//     });
  
//     colltabsider.querySelectorAll('.featured_collection_tab_panel').forEach(function(collsider, index) {
//       const swiperEl = collsider.querySelector('.featured_collection_slider_swiper');
//       if (!swiperEl) return;
//       const prevBtn = colltabsider.querySelector('.featured_collection_slider_button_prev');
//       const nextBtn = colltabsider.querySelector('.featured_collection_slider_button_next');
//       swipers[index] = new Swiper(swiperEl, {
//         slidesPerView: 1.5,
//         spaceBetween: 10,
//         loop: false,
//         observer: true,
//         observeParents: true,
//         watchOverflow: true,
//         navigation: {
//           nextEl: nextBtn,
//           prevEl: prevBtn,
//         },
//         breakpoints: {
//           1024: {
//             slidesPerView: 3.5,
//             spaceBetween: 20
//           }
//         }
//       });
//       swipers[index].on('slideChange', function() {
//         if (prevBtn) {
//           prevBtn.classList.toggle('swiper_button_disabled', swipers[index].isBeginning);
//         }
//         if (nextBtn) {
//           nextBtn.classList.toggle('swiper_button_disabled', swipers[index].isEnd);
//         }
//       });
//       if (prevBtn) prevBtn.classList.add('swiper_button_disabled');
//     });
//   });
// });






